import { render, staticRenderFns } from "./StorageStatusFooter.vue?vue&type=template&id=1a694419&"
import script from "./StorageStatusFooter.vue?vue&type=script&lang=js&"
export * from "./StorageStatusFooter.vue?vue&type=script&lang=js&"
import style0 from "./StorageStatusFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports